export default {
  keyededLatestWeekly: ({ latestWeekly }) => _.keyBy(latestWeekly, 'yearWeek')
}
